import store from 'store2'
import 'logger'

if (window._hmt) {
  let currentCity = store.get('currentCity') || {
    cityEnName: 'shanghai',
    cityName: '上海',
    cityId: 1
  }
  _hmt.push(['_setCustomVar', 1, 'city', currentCity.cityName])
}



// WEBPACK FOOTER //
// ./src/common/tongji.js